namespace $.$$ {
	$mol_style_define( $shm_file_drop, {
		width: '9rem',
		height: '9rem',
		aspectRatio: 1,
		flex: {
			direction: 'column',
			grow: 0,
			shrink: 0,
		},
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		whiteSpace: 'normal',
		overflowWrap: 'anywhere',
		wordBreak: 'normal',
		background: {
			color: $mol_theme.card,
		},
		border: {
			width: '1px',
			style: 'dashed',
			color: $mol_theme.line,
		},
		'@': {
			shm_file_drop_drag: {
				true: {
					color: $mol_theme.focus,
					border: {
						color: $mol_theme.focus,
					},
					background: {
						color: $mol_theme.hover,
					},
				},
			},
		},
		Icon: {
			pointerEvents: 'none',
			width: '2rem',
			height: '2rem',
		},
		Native: {
			pointerEvents: 'none',
			top: 0,
			height: '100%',
		},
		Label: {
			pointerEvents: 'none',
		},
	} )
}
